<template>
    <div>
        <v-select
                :items="filterOptions"
                :label="$t('debugPage.filter')"
                v-model="filter"
        />
        <data-table url="debug_view" :initial-url-search-params="params" :enable-delete="false" :enable-add="false"
                    :enable-edit="false"/>
    </div>
</template>

<script>
    import DataTable from "@/components/monaco/DataTable";

    export default {
        name: "DebugView",
        components: {DataTable},
        data() {
            return {
                filter: 'both'
            }
        },
        computed: {
            filterOptions() {
                return [
                    { text: this.$t('debugPage.filterBoth'), value: 'both' },
                    { text: this.$t('debugPage.filterPassenger'), value: 'passenger' },
                    { text: this.$t('debugPage.filterCaptain'), value: 'captain' },
                ];
            },
            params() {
                const params = new URLSearchParams();

                params.append('filter', this.filter);

                return params;
            }
        },
        title() {
            return this.$t("routeTitles.debugView");
        }
    }
</script>

<style scoped>

</style>